import { MonthlyScheduleItem } from './hooks/useSummaryData'
import useTranslation from 'hooks/useTranslation'
import { displayPrice } from 'utils/string'
import { useState } from 'react'

const Schedule: React.FC<{ schedule?: MonthlyScheduleItem[] }> = ({ schedule }) => {
  const [isExpanded, expand] = useState(false)
  const { t } = useTranslation('basket')

  return (
    <>
      <div className='orderInfo__summary__schedule'>
        {schedule?.map(({ title, price_sum, description, list }, idx) => <div
          key={idx}
          className='orderInfo__summary__schedule__row'>
          <div className='group'>
            <div className='orderInfo__summary__schedule__content'>
              <div>{title}</div>
              {!isExpanded && <div>{description}</div>}
            </div>
            {!isExpanded && <div className='orderInfo__summary__schedule__price'>{displayPrice(price_sum)}</div>}
          </div>
          {isExpanded && list && list.map(({ text, price, type }, listIdx) => <div
            key={listIdx}
            className={`orderInfo__summary__schedule__details group --${type}`}>
            <div>{text}</div>
            <div>{displayPrice(price)}</div>
          </div>)}
          {isExpanded && <div className='orderInfo__summary__schedule__price --right'>
            {displayPrice(price_sum)}
          </div>}
        </div>)}
      </div>
      <div
        className='orderInfo__summary__footer'
        onClick={() => {
          expand(p => !p)
        }}>
        {t(isExpanded ? 'collapse' : 'expand')}
      </div>
    </>
  )
}

export default Schedule